<template>
  <div>
    <div class="extended-filter-block">
      <h2>
        Личный кабинет
      </h2>
    </div>
    <div class="cards-container">
      <div v-if="surveys.length" class="surveys-block">
        <div
            v-for="survey in surveys"
            :key="survey.id"
            class="survey-task-card"
            @click="openSurvey(survey)"
        >
          <a-tag v-if="survey.statusLabel" class="survey-task-card__status" :class="{'ant-tag-green': survey.status === 'new', 'ant-tag-blue': survey.status === 'in_progress'}">
            {{ survey.statusLabel }}
          </a-tag>

          <div class="survey-task-card__body">
            <div class="survey-task-card__content">
              <div class="survey-task-card__title">
                Опрос: {{ survey.title }}
              </div>

              <div class="survey-task-card__meta">
                <a-tag class="survey-task-card__meta-item">
                  <ProfileOutlined class="survey-task-card__meta-icon" />
                  {{ survey.questionsLabel }}
                </a-tag>
                <a-tag class="survey-task-card__meta-item">
                  <ClockCircleOutlined class="survey-task-card__meta-icon" />
                  {{ survey.duration }}
                </a-tag>
                <a-tag v-if="survey.valid_until" class="survey-task-card__meta-item">
                  <CalendarOutlined class="survey-task-card__meta-icon" />
                  Завершить до: {{ survey.valid_until }}
                </a-tag>
              </div>
            </div>

            <RightOutlined class="survey-task-card__arrow" />
          </div>
        </div>
      </div>

      <a-card class="courses-card" :bordered="false">
        <div class="card-header">
          <div class="header-title-block">
            <div class="header-title">
              Развитие
            </div>

            <a-button @click="openStudy" class="secondary-button">
              Смотреть все
            </a-button>
          </div>
          <p class="additional-text">Список активных курсов и тренажеров</p>
        </div>

        <template v-if="courses && courses.length">
          <div class="course-blocks">
            <template v-for="(item, index) in courses" :key="item.url">
              <div v-if="(!showMoreCourses && index < 4) || showMoreCourses">
                  <div
                      :class="['course-item', { 'course-item--clickable': item.url }]"
                      :tabindex="item.url ? 0 : -1"
                      role="link"
                      @click="openCourse(item.url)"
                      @keydown.enter="openCourse(item.url)"
                      @keydown.space.prevent="openCourse(item.url)"
                  >
                    <div class="course-header-block">
                      <div class="course-title">{{ item.title }}</div>
                      <span class="course-link-icon">
                        <RightOutlined />
                      </span>
                    </div>
                    <div class="course-progress">
                      <a-progress :stroke-color="'#21AC0C'" :percent="item.progress ?? 0"  :format="percent => `${percent}%`" />
                    </div>
                  </div>
              </div>
            </template>
          </div>

          <a-button @click="openStudy" class="secondary-button mobile-button">
            Смотреть все
          </a-button>
        </template>

        <div v-else class="no-items-block">
          <div>
            <img src="@/assets/images/no-products.svg" alt="Иконка сообщая об отсутствии продуктов">
          </div>
          <p>Вам еще не были назначены курсы и тренажеры</p>
        </div>
      </a-card>

      <a-card class="tests-card" :bordered="false">
        <div class="card-header">
          <div class="header-title-block">
            <div class="header-title">
              Оценка ЭИ
            </div>

            <a-button v-if="tests.length > 2 && !showMorePassings" @click="() => showMorePassings = true" class="secondary-button">
              Смотреть все
            </a-button>
          </div>
          <p class="additional-text">Ваши текущие и завершенные тестирования</p>
        </div>

        <div v-if="tests && tests.length" class="test-block">
          <template  v-for="(item, index) in tests" :key="item.code" >
            <div v-if="(!showMorePassings && index < 2) || showMorePassings" class="test-item">
              <div>
                <div class="course-title">{{ item.title }}</div>
                <div v-if="item.status !== 'finished'">
                  <p v-if="item.status === 'new'" class="additional-text">Необходимо пройти тестирование</p>
                  <p v-else class="additional-text">
                    Рекомендуется завершить тестирование
                  </p>
                </div>
                <div v-else>
                  <p class="additional-text">
                    Завершен {{ item.finished_at }}
                  </p>
                </div>
              </div>

              <div>
                <div v-if="item.status === 'finished' && canViewAnyReport(item)">
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click.prevent>
                      Скачать отчет
                      <DownOutlined />
                    </a>
                    <template #overlay>
                      <a-menu>
                        <a-menu-item v-if="canViewReport(item, item)" :key="item.code">
                          <span @click="downloadReport(item.code)">
                            {{ item.title }}
                          </span>
                        </a-menu-item>

                        <template v-for="report in item.related_passings" :key="report.code">
                          <template v-if="report.report_type === 'management' && canViewReport(item, report)">
                            <a-menu-item :key="report.code + '-employee'">
                              <span @click="downloadReport(report.code)">
                                {{ getReportName(report.report_type, true) }} — отчет для сотрудника
                              </span>
                            </a-menu-item>
                          </template>

                          <a-menu-item
                              v-else-if="canViewReport(item, report)"
                              :key="report.code"
                          >
                            <span @click="downloadReport(report.code)">
                              {{ getReportName(report.report_type, true) }}
                            </span>
                          </a-menu-item>
                        </template>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>

                <a-button
                    v-else-if="item.status !== 'finished'"
                    size="small"
                    @click="openPassing(item.code)"
                    :class="[
                    'primary-button test-action-btn',
                      item.status === 'finished' ? 'btn-outline' : 'btn-filled'
                  ]">
                  {{ 'Пройти' }}
                </a-button>
              </div>
            </div>
          </template>
          <a-button v-if="tests.length > 2 && !showMorePassings" @click="() => showMorePassings = true" class="secondary-button mobile-button">
            Смотреть все
          </a-button>
        </div>
        <div v-else class="no-items-block">
          <div>
            <img src="@/assets/images/no-products.svg" alt="Иконка сообщая об отсутствии продуктов">
          </div>
          <p>Вам еще не были назначены тестирования</p>
        </div>
      </a-card>
    </div>

    <survey-passing-modal
        :open="surveyPassingOpen"
        :survey-id="activeSurveyId"
        :survey-data="activeSurveyData"
        @close="closeSurveyPassing"
        @completed="handleSurveyCompleted"
    />
  </div>

</template>

<script>
import {CheckCircleFilled, PauseOutlined, DownOutlined, RightOutlined, ProfileOutlined, ClockCircleOutlined, CalendarOutlined} from '@ant-design/icons-vue';
import NewsCommunity from "@/components/Cards/NewsCommunity.vue";
import {onBeforeMount, ref} from "@vue/runtime-core";
import useCheckRights from "@/mixins/useCheckRights";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import getReportName from "@/mixins/getReportName";
import {useRouter} from "vue-router";
import {message} from "ant-design-vue";
import {showDownloadNotification} from "@/mixins/showDownloadNotify";
import SurveyPassingModal from '@/feature/surveys/SurveyPassingModal.vue';
import { getWordFormBasedOnTheCount } from '@/views/Report/utils';

export default {
  name: 'MyDevelopment',
  components: {SurveyPassingModal, NewsCommunity, CheckCircleFilled, PauseOutlined, DownOutlined, RightOutlined, ProfileOutlined, ClockCircleOutlined, CalendarOutlined},
  setup () {

    const {getRight} = useCheckRights(),
    router = useRouter();

    const showTestSummary = ref();
    const detailScores = ref();
    const store = useStore();
    const reportIsGenerating = ref(false);

    const showMoreCourses = ref(false);
    const showMorePassings = ref(false);

    const personalActivity = computed(() => store.state.personalActivity)

    const courses = ref([]);
    const tests = ref([]);

    const surveyPassingOpen = ref(false);
    const activeSurveyId = ref('');
    const activeSurveyData = ref(null);
    const completedSurveyCodes = ref([]);

    const availableSurveys = computed(() => store.state.periodicSurveys.availableSurveys ?? []);

    const getSurveyQuestionCount = (survey) => {
      const questions = survey.questions ?? [];
      const statementQuestions = questions.filter((question) => question.type === 'statement');

      if (!statementQuestions.length) {
        return questions.length;
      }

      return questions.filter((question) => question.type !== 'statement').length + 1;
    };

    const hasSavedSurveyAnswers = (survey) => {
      return Boolean(
          survey.answers?.length
          || survey.passing?.answers?.length
          || survey.questions?.some((question) => question.saved_answers?.length)
      );
    };

    const surveyDurationByPeriod = {
      weekly: '5 минут',
      monthly: '10 минут',
      quarterly: '30 минут',
    };

    const surveys = computed(() => {
      return availableSurveys.value
          .filter((survey) => !completedSurveyCodes.value.includes(survey.code))
          .map((survey) => {
            const hasAnswers = hasSavedSurveyAnswers(survey);
            const questionsCount = getSurveyQuestionCount(survey);

            return {
              id: survey.code,
              code: survey.code,
              title: survey.survey?.name ?? '',
              status: hasAnswers ? 'in_progress' : 'new',
              statusLabel: hasAnswers ? 'Продолжить' : 'Новый',
              questionsLabel: `${questionsCount} ${getWordFormBasedOnTheCount(questionsCount, 'вопрос', 'вопроса', 'вопросов')}`,
              duration: surveyDurationByPeriod[survey.survey?.period] ?? '10 минут',
              valid_until: survey.valid_until,
              source: survey,
            };
          });
    });

    const openPassing = (code) => {
        router.push('/passing/' + code);
    };

    const canViewReport = (item, report) => {
      if (getRight('admin')) {
        return true;
      }

      return Boolean(report?.allow_view_report);
    };

    const canViewAnyReport = (item) => {
      if (getRight('admin')) {
        return true;
      }

      if (item.allow_view_report) {
        return true;
      }

      return item.related_passings?.some((report) => report.allow_view_report) ?? false;
    };

    const downloadReport = (code) => {
      reportIsGenerating.value = true;
      const generationMessageKey = `report-generation-${code}`;
      message.info({
        content: 'Идет генерация отчета, пожалуйста, подождите',
        duration: 0,
        key: generationMessageKey,
      });

      store
          .dispatch("test/getReportLink", code)
          .then(({data}) => {
            if (data) {
              showDownloadNotification(data);
            }
          }).finally(() => {
            message.destroy(generationMessageKey);
            reportIsGenerating.value = false;
          });
    };

    const loadPersonalActivity = () => {
      return store.dispatch('getPersonalActivity').then(() => {
        tests.value = personalActivity.value.passings?.map((passing) => {
           return {
             code: passing.code,
             title: getReportName(passing.report_type, true),
             finished_at: passing.finished_at,
             status: passing.status,
             report_type: passing.report_type,
             allow_view_report: passing.allow_view_report ?? false,
             related_passings: passing.related_passings ?? [],
           }
        });

        courses.value = personalActivity.value.courses?.map((course) => {
          return {
            title: course.name,
            progress: course.percent_completed ?? 0,
            external_id: course.external_id,
            url: course.url ?? null,
          }
        });
      });
    };

    const loadAvailableSurveys = () => {
      return Promise.all([
        store.dispatch("diary/getEmotionList"),
        store.dispatch("periodicSurveys/getAvailable"),
      ]);
    };

    onBeforeMount(() => {
      store.commit("setIsGlobalLoad", true);

      Promise.all([
        loadPersonalActivity().catch(() => null),
        loadAvailableSurveys().catch(() => null),
      ]).finally(() => store.commit("setIsGlobalLoad", false));
    });

    const openStudy = () => {
      router.push('/my-development');
    };

    const openSurvey = (survey) => {
      activeSurveyId.value = survey.source?.survey?.period ?? survey.id;
      activeSurveyData.value = survey.source;
      surveyPassingOpen.value = true;
    };

    const closeSurveyPassing = () => {
      surveyPassingOpen.value = false;
      activeSurveyId.value = '';
      activeSurveyData.value = null;
    };

    const handleSurveyCompleted = ({ code }) => {
      if (code && !completedSurveyCodes.value.includes(code)) {
        completedSurveyCodes.value.push(code);
      }
    };

    const openCourse = (url) => {
      if (!url) return;

      window.open(url, '_blank');
    }

    return {
      courses,
      tests,
      surveys,
      openPassing,
      showTestSummary,
      detailScores,
      getRight,
      getReportName,
      canViewReport,
      canViewAnyReport,
      personalActivity,
      downloadReport,
      reportIsGenerating,
      showMoreCourses,
      showMorePassings,
      openStudy,
      openCourse,
      openSurvey,
      surveyPassingOpen,
      activeSurveyId,
      activeSurveyData,
      closeSurveyPassing,
      handleSurveyCompleted,
    }
  }
}
</script>

<style lang="scss" scoped>

.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.cards-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
}

.surveys-block {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  overflow: visible;

  @media (min-width: $tablet-breakpoint) {
    grid-column: 1 / -1;
  }
}

.survey-task-card {
  position: relative;
  padding: 20px;
  background: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  overflow: visible;
}

:deep(.survey-task-card__status.ant-tag) {
  position: absolute;
  top: 0;
  left: 20px;
  z-index: 1;
  margin-inline-end: 0;
  padding: 4px 8px;
  transform: translateY(-50%);

  font-weight: 400;
  font-size: 12px;
  line-height: 110%;
}

.survey-task-card__body {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-top: 4px;
}

.survey-task-card__content {
  flex: 1;
  min-width: 0;
}

.survey-task-card__title {
  text-align: left;
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.survey-task-card__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.survey-task-card__meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  margin: 0;
  font-size: 12px;
  line-height: 120%;
  color: var(--main-font);
  background: var(--light-grey);
  border: 1px solid var(--border-grey);
  border-radius: 4px;
}

.survey-task-card__meta-icon {
  font-size: 12px;
}

.survey-task-card__arrow {
  flex-shrink: 0;
  margin-top: 1px;
  font-size: 14px;
  color: var(--neutral-fade-black-font);
}

.survey-task-card:hover .survey-task-card__arrow {
  color: var(--main-green);
}

.courses-card,
.tests-card {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.courses-card :deep(.ant-card-body),
.tests-card :deep(.ant-card-body) {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.courses-card {
  border-radius: 8px;
  background: #fff;
}

.card-header {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  text-align: left;
  font-weight: 600;
}

.course-item {
  text-align: left;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 16px;
}

.course-item--clickable {
  cursor: pointer;
}

.course-link-icon {
  color: var(--main-font);
  transition: color 0.2s ease;
}

.course-item:hover .course-link-icon,
.course-item:focus-visible .course-link-icon {
  color: var(--main-green);
}

.course-title {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  color: var(--main-font);
  white-space: wrap;
  text-align: left;
}

.course-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.test-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 16px;
}

.test-status-badge {
  align-self: flex-start;
  font-size: 12px;
  padding: 0 8px;
  text-transform: lowercase;
}

.segmented-progress {
  display: flex;
  gap: 2px;
}

.segment-completed .segment.filled {
  background-color: var(--main-green);
}

.segment {
  width: 2px;
  height: 6px;
  background-color: #d9d9d9;
  transition: background-color 0.2s ease;
}

.segment.filled {
  background-color: var(--main-blue);
}

.progress-percent {
  font-size: 12px;
  color: #888;
}

.status-icon {
  display: flex;
  align-items: center;
}

.view-all-btn,
.view-all-header-btn {
  padding: 0;
  font-size: 14px;
  color: var(--main-font);
  border: 1px solid var(--grey-text);
  border-radius: 4px;
  text-align: center;
  width: 120px;
}

.view-all-btn:hover,
.view-all-header-btn:hover {
  background-color: var(--polar-green);
  color: var(--main-green);
}

.view-all-btn {
  display: none;
  margin-top: 20px;

  @media (max-width: 500px) {
    display: block;
  }
}

.view-all-header-btn {
  @media (max-width: 500px) {
    display: none;
  }
}

.test-action-btn {
  font-family: "Open Sans", sans-serif;
  margin-top: 10px;
  align-self: flex-start;
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 4px;
  height: auto;
  border: 1px solid transparent;
}

.btn-filled {
  background-color: var(--main-green);
  color: white;
}

.btn-filled:hover {
  border-color: var(--main-green);
  background-color: var(--polar-green-6);
  color: white;
}

.btn-outline {
  color: var(--main-green);
  border: 1px solid var(--main-green);
  background: transparent;
}

.btn-outline:hover {
  color: var(--main-green);
  border-color: var(--main-green);
  background-color: var(--polar-green);
}

@media (min-width: $tablet-breakpoint) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: $tablet-breakpoint) and (min-width: $mobile-breakpoint) {
  .cards-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .card-header {
    font-size: 15px;
  }

  .course-item,
  .test-item {
    padding: 20px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .courses-card,
  .tests-card {
    box-shadow: none;
    border: 1px solid #f0f0f0;
  }

  .card-header {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .course-item,
  .test-item {
    padding: 10px;
    gap: 15px;
  }

  .course-title {
    font-size: 13px;
    white-space: normal;
  }

  .test-status-badge {
    font-size: 11px;
  }

  .test-action-btn {
    width: 100%;
    text-align: center;
    font-size: 13px;
  }

  .view-all-btn {
    width: 100%;
    margin-top: 12px;
    font-size: 14px;
  }
}

.courses-card,
.tests-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
}

.course-item,
.test-item {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 16px;
}

.no-items-block {
  padding: 40px 0;
  margin: auto;
}

.additional-text {
  color: var(--grey-text);
  margin-bottom: 0;
  text-align: left;
}

.ant-dropdown-link {
  color: var(--main-green);
}

.test-block,
.course-blocks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.header-title-block,
.course-header-block {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.course-link-icon {
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 1px;
}

.download-report-button {
  margin-top: auto;
}

.secondary-button {
  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

.secondary-button.mobile-button {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
  }
}

.test-action-btn {
  font-size: 14px;
}
</style>
